import {observable, computed} from 'mobx';

import InputModel from '../models/InputModel'
import OutputModel from '../models/OutputModel'
import SelectionModel from '../models/SelectionModel'
import BaseEntriesStore from './BaseEntriesStore'


class CommonEntriesStore {


    @observable title = "Title";

    @observable deckendicke = 10;

    @computed get totalValue(){

        var out = new OutputModel("Gesamtkosten für " + BaseEntriesStore.dickeforderlichob.value +' cm Decke',"Gesamtkosten für" + BaseEntriesStore.dickeforderlichob.value +' cm Decke',0.0,'€/m²');
        return out;
    }
    @computed get totalValueBrespa(){
        var out =  new OutputModel("Gesamtkosten für " + BaseEntriesStore.dickeforderlichbrespa +' cm Decke',"Gesamtkosten für" + BaseEntriesStore.dickeforderlichbrespa +' cm Decke',0.0,'€/m²');
        return out;
    }
    @computed get totalValueBrespaStuetzung(){
        var out =  new OutputModel("Gesamtkosten Decke","Gesamtkosten für Decke",0.0,'€/m²');
        return out;
    }
    @computed get totalKostenStuetzung() {
        var out = new OutputModel("Mehrkosten für zusätzlich <br/>erforderliche Deckenauflager", "Mehrkosten für zusätzlich <br/>erforderliche Deckenauflager", 0.0, '€/m²');
        return out;
    }

    @computed get deckenhoehe(){
        var out = new OutputModel("Deckenhöhe","Deckenhöhe",0.0,'m');
        return out;
    }
    @computed get kosten_qm(){
        var out = new OutputModel("Kosten pro qm","Kosten pro qm",0.0,'€/m²');
        return out;
    }
    @computed get zeitverbrauch(){
        var out = new OutputModel("Zeitverbrauch","Zeitverbrauch",0.0,'h');
        return out;
    }

     round(value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }

}
export default CommonEntriesStore;




// WEBPACK FOOTER //
// ./src/stores/CommonEntriesStore.js